// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* VARIABLES
*/
/*
* MIXINS
*/
.Banner {
  position: relative;
  width: 100%;
  display: flex;
  align-items: flex-end;
  height: 90vh;
  background: #141414;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
}
@media (min-width: 1024px) {
  .Banner {
    height: 80vh;
    align-items: center;
  }
}
.Banner__loadsection .loading,
.Banner__loadsection .errored {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80vh;
  background: #141414;
  font-size: 20px;
  line-height: 1.6;
  font-weight: 600;
  text-shadow: 2px 2px 4px rgba(20, 20, 20, 0.45);
}
.Banner__content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 0 4vw;
  padding-bottom: 10vh;
  z-index: 1;
}
@media (min-width: 1024px) {
  .Banner__content {
    align-items: flex-start;
    padding-bottom: unset;
    text-align: left;
  }
}
.Banner__content--title {
  font-size: 30px;
  line-height: 1;
  text-shadow: 2px 2px 4px rgba(20, 20, 20, 0.45);
}
@media (min-width: 400px) {
  .Banner__content--title {
    font-size: 35px;
  }
}
@media (min-width: 640px) {
  .Banner__content--title {
    font-size: 40px;
  }
}
@media (min-width: 768px) {
  .Banner__content--title {
    font-size: 60px;
  }
}
@media (min-width: 1024px) {
  .Banner__content--title {
    max-width: 50%;
  }
}
.Banner__content--description {
  font-size: 14px;
  line-height: 1.6;
  text-shadow: 2px 2px 4px rgba(20, 20, 20, 0.45);
  margin-top: 1rem;
}
@media (min-width: 640px) {
  .Banner__content--description {
    font-size: 16px;
  }
}
@media (min-width: 768px) {
  .Banner__content--description {
    font-size: 2vw;
    max-width: 60vw;
  }
}
@media (min-width: 1024px) {
  .Banner__content--description {
    font-size: 1.2vw;
    max-width: 30vw;
    margin-top: 1vw;
  }
}
.Banner__buttons {
  display: flex;
  align-items: center;
  margin-top: 1vw;
}
.Banner__button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-width: 120px;
  background-color: rgba(109, 109, 110, 0.7);
  color: #f2f2f2;
  padding: 10px 16px;
  margin-left: 10px;
  border-radius: 6px;
  border: 0;
  margin-top: 1em;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.2s ease-out;
}
@media (min-width: 400px) {
  .Banner__button {
    min-width: 150px;
    font-size: 14px;
    padding: 12px 20px;
  }
}
@media (min-width: 768px) {
  .Banner__button {
    font-size: 15px;
  }
}
.Banner__button:hover {
  background-color: #6d6d6e;
}
.Banner__button:first-child {
  margin-left: 0;
  background-color: #e50914;
  color: #f2f2f2;
}
.Banner__button:first-child:hover {
  background-color: rgb(204.4642857143, 8.0357142857, 17.8571428571);
}
.Banner__button span {
  margin-left: 8px;
}
.Banner__panel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background-color: rgba(20, 20, 20, 0.2);
}
.Banner__bottom-shadow {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 7.5rem;
  background: linear-gradient(180deg, transparent, rgba(14, 14, 14, 0.6), #141414);
}`, "",{"version":3,"sources":["webpack://./src/scss/_mixin.scss","webpack://./src/components/Banner/banner.scss","webpack://./src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKA;;CAAA;ACFA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;EACA,mBCNI;EDOJ,sBAAA;EACA,4BAAA;EACA,+BAAA;AAIJ;AD4DQ;ECzER;IAYQ,YAAA;IACA,mBAAA;EAKN;AACF;AAFQ;;EAEI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBCxBJ;EDyBI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,+CAAA;AAIZ;AAAI;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,UAAA;AAER;AD+BQ;ECzCJ;IAWQ,uBAAA;IACA,qBAAA;IACA,gBAAA;EAGV;AACF;AADQ;EACI,eAAA;EACA,cAAA;EACA,+CAAA;AAGZ;ADmBQ;ECzBA;IAMQ,eAAA;EAId;AACF;ADcQ;ECzBA;IASQ,eAAA;EAMd;AACF;ADSQ;ECzBA;IAYQ,eAAA;EAQd;AACF;ADIQ;ECzBA;IAeQ,cAAA;EAUd;AACF;AAPQ;EACI,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,gBAAA;AASZ;ADPQ;ECNA;IAOQ,eAAA;EAUd;AACF;ADZQ;ECNA;IAUQ,cAAA;IACA,eAAA;EAYd;AACF;ADlBQ;ECNA;IAcQ,gBAAA;IACA,eAAA;IACA,eAAA;EAcd;AACF;AAVI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;AAYR;AATI;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,0CAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,eAAA;EACA,gCCrGI;EDsGJ,eAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,6BAAA;AAWR;ADjDQ;ECqBJ;IAoBQ,gBAAA;IACA,eAAA;IACA,kBAAA;EAYV;AACF;ADxDQ;ECqBJ;IA0BQ,eAAA;EAaV;AACF;AAXQ;EACI,yBAAA;AAaZ;AAVQ;EACI,cAAA;EACA,yBChIN;EDiIM,cCrIJ;ADiJR;AAVY;EACI,kEAAA;AAYhB;AARQ;EACI,gBAAA;AAUZ;AANI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;AAQR;AALI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,cAAA;EACA,gFAAA;AAOR","sourcesContent":["/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","@import '../../scss/mixin';\n@import '../../scss/variables';\n\n.Banner {\n    position: relative;\n    width: 100%;\n    display: flex;\n    align-items: flex-end;\n    height: 90vh;\n    background: $black;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: top center;\n\n    @include mq(lg) {\n        height: 80vh;\n        align-items: center;\n    }\n\n    &__loadsection {\n        .loading,\n        .errored {\n            width: 100%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            height: 80vh;\n            background: $black;\n            font-size: 20px;\n            line-height: 1.6;\n            font-weight: 600;\n            text-shadow: 2px 2px 4px rgba($color: $black, $alpha: 0.45);\n        }\n    }\n\n    &__content {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n        padding: 0 4vw;\n        padding-bottom: 10vh;\n        z-index: 1;\n\n        @include mq(lg) {\n            align-items: flex-start;\n            padding-bottom: unset;\n            text-align: left;\n        }\n\n        &--title {\n            font-size: 30px;\n            line-height: 1;\n            text-shadow: 2px 2px 4px rgba($color: $black, $alpha: 0.45);\n\n            @include mq('xs'){\n                font-size: 35px;\n            }\n            @include mq('sm'){\n                font-size: 40px;\n            }\n            @include mq('md'){\n                font-size: 60px;\n            }\n            @include mq('lg'){\n                max-width: 50%;\n            }\n        }\n        \n        &--description {\n            font-size: 14px;\n            line-height: 1.6;\n            text-shadow: 2px 2px 4px rgba($color: $black, $alpha: 0.45);\n            margin-top: 1rem;\n\n            @include mq('sm'){\n                font-size: 16px;\n            }\n            @include mq('md'){\n                font-size: 2vw;\n                max-width: 60vw;\n            }\n            @include mq('lg'){\n                font-size: 1.2vw;\n                max-width: 30vw;\n                margin-top: 1vw;\n            }\n        }\n    }\n\n    &__buttons {\n        display: flex;\n        align-items: center;\n        margin-top: 1vw;\n    }\n    \n    &__button {\n        display: inline-flex;\n        justify-content: center;\n        align-items: center;\n        min-width: 120px;\n        background-color: rgba(109, 109, 110, 0.7);\n        color: #f2f2f2;\n        padding: 10px 16px;\n        margin-left: 10px;\n        border-radius: 6px;\n        border: 0;\n        margin-top: 1em;\n        font-family: $main-font;\n        font-size: 13px;\n        font-weight: 500;\n        cursor: pointer;\n        text-decoration: none;\n        transition: all 0.2s ease-out;\n\n        @include mq('xs'){\n            min-width: 150px;\n            font-size: 14px;\n            padding: 12px 20px;\n        }\n\n        @include mq('md'){\n            font-size: 15px;\n        }\n\n        &:hover {\n            background-color: rgba(#6d6d6e, 1);\n        }\n\n        &:first-child {\n            margin-left: 0;\n            background-color: $red;\n            color: $white;\n\n            &:hover {\n                background-color: darken($red, 5);\n            }\n        }\n\n        span {\n            margin-left: 8px;\n        }\n    }\n\n    &__panel {\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 0;\n        background-color: rgba($color: $black, $alpha: 0.2);\n    }\n\n    &__bottom-shadow {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 7.5rem;\n        background: linear-gradient(180deg, transparent, rgba(14, 14, 14, 0.6), $black);\n    }\n}","$white: #f2f2f2;\n$pure-black: #030303;\n$light-black: #181818;\n$black: #141414;\n$red: #e50914;\n$grey: #101011;\n$blue-google: #1356c7;\n\n$main-font: 'Inter', sans-serif;\n$fakeflix-font: 'Bebas Neue', cursive;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
